import { useFlashMessagesStore } from '~/stores/flash_message'

export default defineNuxtRouteMiddleware(() => {
    if (process.client) {
        useFlashMessagesStore().reload()
    }
})
